import api from './api/api';

class WaitingScreenService {
  get() {
    return api.get('/waitingscreen/get/');
  }

  getAdmin() {
    return api.get('/waitingscreen/admin/get/');
  }

  update(data) {
    return api.post('/waitingscreen/update/', data);
  }

  uploadFile(formData) {
    return api.post('/file/upload/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default new WaitingScreenService();
